import React from "react";

import { HERO_SLIDES } from "../../data/content";
import Slideshow from "./Slideshow";

const prefersReducedMotion = () => window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

//Full-width banner at the top of a page: the shared slideshow (default), one photo, or a video (Kitchens)
const PageHero = ({ photo = null, video = null, poster = null }) => {
  if (video) {
    return (
      <div className={"page-hero"}>
        <video
          src={video}
          poster={poster}
          autoPlay={!prefersReducedMotion()}
          muted
          loop
          playsInline
          preload={"metadata"}
          aria-hidden={"true"}
        />
      </div>
    );
  }
  if (photo) {
    return (
      <div className={"page-hero"}>
        <img
          src={photo.src}
          srcSet={photo.srcSet}
          sizes={"100vw"}
          alt={photo.alt}
          width={photo.width}
          height={photo.height}
        />
      </div>
    );
  }
  return (
    <div className={"page-hero"}>
      <Slideshow
        photos={HERO_SLIDES}
        label={"Graylag & Co projects"}
        variant={"hero"}
        autoPlay={5000}
        showDots
      />
    </div>
  );
};

export default PageHero;
